import { Button, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import PasscodeInput from "../../../../../components/passcodeInput/PasscodeInput"
import useMultiInputFocus from "../../../../../hooks/useMultiInputFocus"
import { useUserQuery } from "../../../../../networking/queries"
import {
  EnterParentPasscodeType,
  ParentPasscodeStep,
} from "../../../../../types"
import { useParentPasscodeModalStore } from "../useParentPasscodeModalStore"

const EnterPasscode = () => {
  const { user } = useUserQuery()
  const {
    setStep,
    currentPasscode,
    setCurrentPasscode,
    showError,
    setShowError,
    enterType,
  } = useParentPasscodeModalStore()
  const { t } = useTranslation()

  const {
    ref: passcodeInputRef,
    focusFirstInput,
    clearInputs,
  } = useMultiInputFocus({ useEffectDelay: 200 })

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (
      user?.account_passcode === currentPasscode ||
      user?.parent_panel_passcode === currentPasscode
    ) {
      setShowError(false)
      switch (enterType) {
        case EnterParentPasscodeType.UPDATE_CODE:
          setStep(ParentPasscodeStep.CHANGE_PASSCODE)
          break
        case EnterParentPasscodeType.TURN_OFF_CODE:
          setStep(ParentPasscodeStep.DELETE_PASSCODE)
          break
        case EnterParentPasscodeType.UPDATE_REQUIREMENT:
          setStep(ParentPasscodeStep.REQUIREMENTS)
          break
        default:
          setStep(ParentPasscodeStep.CHANGE_PASSCODE)
      }
    } else {
      setCurrentPasscode("")
      focusFirstInput()
      clearInputs()
      setShowError(true)
    }
  }

  const titleText = () => {
    switch (enterType) {
      case EnterParentPasscodeType.UPDATE_CODE:
        return t("PPC_ENTER_CURRENT")
      case EnterParentPasscodeType.TURN_OFF_CODE:
        return t("PPC_ENTER_CURRENT_TURN_OFF")
      case EnterParentPasscodeType.UPDATE_REQUIREMENT:
        return t("PPC_ENTER_CURRENT_UPDATE_REQ")
      default:
        return t("PPC_ENTER_CURRENT")
    }
  }

  const buttonText = () => {
    switch (enterType) {
      case EnterParentPasscodeType.TURN_OFF_CODE:
        return t("PPC_TURN_OFF_ACCESS_CODE")
      default:
        return t("PPC_NEXT")
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4">
        <Typography variant="bodyBold">{titleText()}</Typography>

        <PasscodeInput
          value={currentPasscode}
          setValue={setCurrentPasscode}
          ref={passcodeInputRef}
        />

        <Button
          text={buttonText()}
          type="submit"
          fullWidth
          disabled={currentPasscode.length !== 4}
        />
        {showError && (
          <Typography variant="bodySmall" color={JoonUIColor.semantic.alert}>
            {t("PPC_ERR_INCORRECT")}
          </Typography>
        )}
      </div>
    </form>
  )
}

export default EnterPasscode
